export const related = [
  '/puzzles/art-gallery-evacuation-zone',
  '/puzzles/urban-fresh-code',
  '/puzzles',
];
export const quickAnswer =
  'Treadmill 0.5 → Bike 15 → Vending Machine → Treadmill 15 → Bike 0.5.';
export const sourceIds = ['powerpyx-hideouts'];
export const diagram = {
  src: '/diagrams/pulse-fitness-sequence.svg',
  alt: 'Five actions: treadmill 0.5, bike 15, vending machine, treadmill 15, bike 0.5.',
  width: 1100,
  height: 260,
};

## Where to Find Pulse Fitness

Find the Pulse Fitness shop in The Unknown. Look for its purple sign.

## Correct Machine Order

1. Interact with the treadmill marked 0.5.
2. Use the bike marked 15.
3. Interact with the vending machine.
4. Use the treadmill marked 15.
5. Finish at the bike marked 0.5.

## Why You May See an Art Gallery Instead

This area has opposite gravity orientations. If the location leads to an art gallery, change orientation to reach the street with Pulse Fitness.

## Puzzle Not Working?

Match both the machine type and its speed label. The first bike and final treadmill both use 15; the final bike uses 0.5. Once the room opens, collect the health-upgrade item.
